<script>
export default {
  name: "DidoApidocUsage",
};
</script>

<script setup>
import DidoApidocUsageEntrypoint from "./usage/Entrypoint.vue";
import DidoApidocUsageAuthentication from "./usage/Authentication.vue";
import DidoApidocUsageResources from "./usage/Resources.vue";
import DidoApidocUsagePagination from "./usage/Pagination.vue";
import DidoApidocUsageErrrors from "./usage/Errors.vue";
import DidoApidocUsageOutputFormats from "./usage/OutputFormats.vue";
import DidoApidocUsageSorting from "./usage/Sorting.vue";
import DidoApidocUsageColumns from "./usage/Columns.vue";
import DidoApidocUsageFiltering from "./usage/Filtering.vue";
import DidoApidocUsageGeofields from "./usage/Geofields.vue";
import DidoApidocUsageRoutes from "./usage/Routes.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
});
</script>

<template>
  <div class="q-ml-md">
    <!-- Entrypoint -->
    <QExpansionItem
      id="entrypoint"
      label="3.1 - Point d'entrée de l'API"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageEntrypoint :api-url="props.apiUrl" />
    </QExpansionItem>
    <!-- Authentication -->
    <QExpansionItem
      id="authentication"
      label="3.2 - Authentification et autorisation"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageAuthentication />
    </QExpansionItem>
    <!-- Resources id -->
    <QExpansionItem
      id="resources-id"
      label="3.3 - Identifiants d'url"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageResources />
    </QExpansionItem>
    <!-- Data pagination -->
    <QExpansionItem
      id="pagination"
      label="3.4 - Pagination des données"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsagePagination />
    </QExpansionItem>
    <!-- Errors -->
    <QExpansionItem
      id="errors"
      label="3.5 - Gestion des erreurs"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageErrrors />
    </QExpansionItem>
    <!-- Output formats -->
    <QExpansionItem
      id="output-formats"
      label="3.6 - Formats de sortie"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageOutputFormats />
    </QExpansionItem>
    <!-- Sort Clause -->
    <QExpansionItem
      id="sort-clause"
      label="3.7 - Tri des données"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageSorting />
    </QExpansionItem>
    <!-- Columns selection -->
    <QExpansionItem
      id="select-columns"
      label="3.8 - Sélection des colonnes"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageColumns />
    </QExpansionItem>
    <!-- Data Filtering -->
    <QExpansionItem
      id="filter-clause"
      label="3.9 - Filtrer les données"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageFiltering />
    </QExpansionItem>
    <!-- Geofields -->
    <QExpansionItem
      id="geofield-clause"
      label="3.10 - Champs de projection géographique"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageGeofields />
    </QExpansionItem>
    <!-- Detail of operations -->
    <QExpansionItem
      id="operations-list"
      label="3.11 - Liste des opérations"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocUsageRoutes :api-url="props.apiUrl" />
    </QExpansionItem>
  </div>
</template>
